import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { isSuperthemHost } from '../../utils/SuperthemHostUtil';

const SuperthemUpgradeNoticeModal: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isSuperthemHost()) {
      setVisible(true);
    }
  }, []);

  return (
    <Modal
      title="圆领升级通知"
      open={visible}
      centered
      width={480}
      okText="知道了"
      cancelButtonProps={{ style: { display: 'none' } }}
      onOk={() => setVisible(false)}
      onCancel={() => setVisible(false)}
    >
      <p style={{ marginBottom: 0, lineHeight: 1.7, fontSize: 15 }}>
        2026年10月1日起，圆领全新升级，后续 superthem.com 将会作为圆领海外站入口，国内请使用{' '}
        <a href="https://yuanling.com" target="_blank" rel="noopener noreferrer">
          yuanling.com
        </a>{' '}
        访问，卖家入口：{' '}
        <a href="https://seller.yuanling.com" target="_blank" rel="noopener noreferrer">
          seller.yuanling.com
        </a>
        。
      </p>
    </Modal>
  );
};

export default SuperthemUpgradeNoticeModal;
